
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="getReport" -->
				<!-- <el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getReport" placeholder="姓名"></el-input>
				</el-form-item> -->
 				<el-form-item v-if="TenancyId=='0'||TenancyId==null">
                <el-select  v-model="shopId" clearable filterable placeholder="选择或搜索门店" @change="ChangeList" >
                 <el-option
               v-for="item in optionsShop"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				 
                   </el-form-item>               
				<el-form-item>
                <el-select  v-model="CoachId" clearable filterable  placeholder="请选择教练" >
                <el-option
                  v-for="item in options"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id">
               </el-option>
                 </el-select>
				</el-form-item>                
                <el-form-item >

<el-date-picker
      v-model="valuePicker"
      type="daterange"
      value-format="yyyy-MM-dd"
      align="right"
      unlink-panels
      range-separator="至"
      :picker-options="pickerDisabled"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @change='changeDate'
    >
    </el-date-picker>
            </el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getReport" icon="el-icon-search">统计</el-button>
					<el-button size="width:100%; height:100%;" type="warning" :loading="reportLoading" v-on:click="exportReport" icon="el-icon-search">导出总计</el-button>					
				</el-form-item>		
			</el-form>
		</el-col>
		<!--列表-->
		<el-table  show-summary   :summary-method="getSummaries" :data="coachList" highlight-current-row v-loading="listLoading"  style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" width="80" >
			</el-table-column>
            <el-table-column prop="Day" label="培训日期" width="150" sortable>
			</el-table-column> 
			<el-table-column prop="Number" label="教练编号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Phone" label="电话" width="150" sortable>
			</el-table-column>
 			<el-table-column prop="Frequency" label="已培训次数" width="150" sortable>
			</el-table-column>          
			<el-table-column prop="Count" label="已培训人数" min-width="150" sortable>
			</el-table-column>
			<el-table-column label="操作" width="100">
				<template  slot-scope="scope">
					<!-- <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
					<!-- <el-button :ref="scope.Id" type="primary" size="small"   @click="exportReportDetail(scope.row)">导出明细</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
         <!-- <template slot-scope="scope"> -->
		<el-col  :span="24" class="toolbar" v-for="item  in studentList" :key="item.Month">
            <!-- {{item}} -->
            <el-table show-summary  :summary-method="studentGetSummaries" :data="item.StudentList"  highlight-current-row v-loading="listLoading"  style="width:1702px"  >
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" width="80" >
			</el-table-column>
            <el-table-column prop="Day" label="培训日期" width="150" sortable>
			</el-table-column>     
			<el-table-column prop="CardNumber" label="会员卡号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Phone" label="电话" width="150" sortable>
			</el-table-column>
       
			<el-table-column prop="Count" label="培训次数" min-width="150" sortable>
			</el-table-column>
		</el-table>
         
		</el-col>
           <!-- </template> -->
         
		</section>
</template>

<script>
	import util from '../../common/js/util'
import {mapGetters} from 'vuex';
	//import NProgress from 'nprogress'
	import { getCoachOptionsList,ReportDay ,ExportReportDetail,ExportReportDay,getShopInfor} from '../../api/api';

	export default {
		data() {
			return {
      valuePicker: [],
        pickerDisabled: {
          disabledDate: (time) => {
            return time.getTime() > Date.now() - 8.64e7;
      }
          },                
                TenancyId:'',
                shopId:'',
                optionsShop:[],
				filters: {
					Name: ''
                },
                items:[
                   { message: 'Foo' },
                    { message: 'Bar' }
                ],
                CoachId:'',
                monthValueStart:'',
                monthValueEnd:'',
				Count:0,
				options:[],
                coachList:[],
                Members:[],
                studentList:[],
				listLoading: false,
				reportLoading:false,
			}
		},
		methods: {
        changeDate(){
        // 从配置项S0031中去默认查询天数
        let mrdays=30
		// 所选日期差
		console.log(this.valuePicker)
		      let sdatetime=new Date(this.valuePicker[1]).getTime();
      let ddatetime=new Date(this.valuePicker[0]).getTime();
      var day=parseInt((sdatetime-ddatetime)/1000/60/60/24);
        if(day>mrdays){
            this.$message({
              message: '所选日期查询范围大于配置项'+mrdays+'天，请重新选择',
              type: 'warning'
            });
            this.valuePicker=[];
        }
      },      
         ChangeList()
         {
             console.log('1');
              this.getCoachList();           
         },   
	           ...mapGetters(['getuserstate']),
	
		
		studentGetSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
			}, 0);
			if(index===6)
			{
			if(index===6)
			{
            sums[index] += ' 次';
			}			
			}
			else
			{
            sums[index] = '';
			}
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
	     getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
			}, 0);
			if(index===6||index===7)
			{
			if(index===6)
			{
            sums[index] += ' 次';
			}
			if(index===7)
			{
            sums[index] += ' 人';
			}
			}
			else
			{
            sums[index] = '';
			}
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
    
		exportReportDetail(row){
			let downloadName=row.Name+"-"+row.Month+"明细报表";

			     let para = {
					CoachId: row.Id,					
					monthValueStart:row.Month,
				};  
				 ExportReportDetail(para).then((res)=>{	
				
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = downloadName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
		   })
			},
		exportReport()
			{
				this.reportLoading=true;
			    if(this.CoachId=='')
                {
                    			this.$message({
									message: '请选择教练',
									type: 'error'
                                });
								this.reportLoading=false;
                                return;
                }

                if(this.valuePicker.length<1)
                {
                    			this.$message({
									message: '请选择时间范围',
									type: 'error'
                                });
								this.reportLoading=false;
                                return;
                }
				 let para = {
					CoachId: this.CoachId,					
					DateTimeStr:this.valuePicker,

				};  
  				let downloadName="总计报表";

				 ExportReportDay(para).then((res)=>{	
					 
					 let {status}=res;	
					//  console.log(status);
					 if(status==200)
					 {
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = downloadName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
						 this.reportLoading=false;

					 }
					 else
					 {
						 this.reportLoading=false;
					 }

		   })
			},
			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},

			getReport() {

                if(this.CoachId=='')
                {
                    			this.$message({
									message: '请选择教练',
									type: 'error'
                                });
                                return;
                }

                if(this.valuePicker.length<1)
                {
                    			this.$message({
									message: '请选择时间范围',
									type: 'error'
                                });
                                return;
                }             
				let para = {
					CoachId: this.CoachId,					
					DateTimeStr:this.valuePicker,
				};
				this.listLoading = true;
				ReportDay(para).then((res) => {
                 
                     this.coachList=res.data.Data.CoachReportList;
                     //this.studentList=res.data.Data.StudentReportList;
                                        //   console.log(res.data.Data.CoachReportList);
                                        //   console.log(res.data.Data.StudentReportList);
								let { Success,Msg } = res.data;
								if(Success)
								{			
								this.$message({
									message: Msg,
									type: 'success'
								});
								}
								else
								{
									this.$message({message:Msg,type:'error'});
								}
					// this.total = res.data.TotleCount;
					// this.Members =res.data.Data;
                    // this.Count=res.data.TotleCount;
					this.listLoading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
            },		
            
            getCoachList()
            {
                let para={
                    TenancyId:this.shopId
                }
            getCoachOptionsList(para).then((res)=>{
					//  console.log(res);
              this.options=res.data;
				 }).catch(error=>{
             }) 
            },
          getShopList()
           {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.optionsShop = res.data;
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
           },               

		},
		mounted() {
            // this.getCoachList();
            this.TenancyId=JSON.parse(this.getuserstate()).TenancyId;
            this.getShopList();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// CoachlogReportDay.vue?eb84ac78